module.exports = ($stateProvider) => {
    $stateProvider
        .state('print', {
            abstract: true,
            url: '/print',
            parent: 'root',
            views: {
                '@': {
                    template: '',
                },
            },
        })
        .state('print.recipe', {
            url: '^/shop/printrecipe/{recipeId}',
            data: {
                pageMetadata: {
                    title: 'Shop Print Recipe - Woolworths Online',
                    metaDescription: 'Shop Print Recipe',
                    metaRobot: 'noindex',
                },
            },
            resolve: {
                recipe: ['RecipeService', '$stateParams', function (recipeService, $stateParams) {
                    return recipeService.getRecipe($stateParams.recipeId).then(recipe => recipe);
                }],
            },
            views: {
                '@': {
                    controller: [
                        'recipe', function (recipe) {
                            this.recipe = recipe;
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: '<wow-recipe-print recipe="$ctrl.recipe"></wow-recipe-print>',
                },
            },
        })
        .state('print.orderconfirmation', {
            url: '^/checkout/printconfirmation?{OrderID}',
            data: {
                pageMetadata: {
                    title: 'Print Order Confirmation - Woolworths Online',
                    metaDescription: 'Print Order Confirmation',
                    metaRobot: 'noindex',
                },
            },
            resolve: {
                orderConfirmation: [
                    '$ocLazyLoad', '$injector', '$stateParams', function ($ocLazyLoad, $injector, $stateParams) {
                        return $ocLazyLoad.load('checkout').then(() => {
                            const checkoutService = $injector.get('CheckoutService');
                            return checkoutService.getOrderConfirmation($stateParams.OrderID);
                        });
                    },
                ],
            },
            views: {
                '@': {
                    controller: [
                        '$scope', 'orderConfirmation',
                        function ($scope, orderConfirmation) {
                            $scope.order = orderConfirmation.Order;
                        },
                    ],
                    template: '<wow-order-confirmation-print order="order"></wow-order-confirmation-print>',
                },
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/print.js